var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.08076 0H3.91924C1.76722 0 0 1.81263 0 4.05263V7.58947C0 7.91368 0.256532 8.17895 0.570071 8.17895C0.88361 8.17895 1.14014 7.91368 1.14014 7.58947V4.05263C1.14014 2.47579 2.38005 1.19368 3.90499 1.19368H8.05226C9.6057 1.19368 10.8456 2.47579 10.8456 4.05263V7.14737C10.8456 8.72421 9.6057 10.0063 8.08076 10.0063H2.93587L4.66033 8.22316C4.88836 7.98737 4.88836 7.61895 4.66033 7.38316C4.4323 7.14737 4.07601 7.14737 3.84798 7.38316L1.14014 10.1832C0.912114 10.4189 0.912114 10.7874 1.14014 11.0232L3.84798 13.8232C3.962 13.9411 4.10451 14 4.26128 14C4.4038 14 4.56057 13.9411 4.67458 13.8232C4.90261 13.5874 4.90261 13.2189 4.67458 12.9832L2.93587 11.2H8.08076C10.247 11.2 12 9.38737 12 7.14737V4.05263C12 1.81263 10.2328 0 8.08076 0Z",
    fill: "#FFF057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetIcon);
export default __webpack_public_path__ + "static/media/reset-icon.eb2c71f20a56553252fb71e896e3acbb.svg";
export { ForwardRef as ReactComponent };